import Application from './javascript/Application';
import jwtDecode from 'jwt-decode';
import envierments from './Environments/envierments';
import RedirectService from './javascript/RedirectService';
import { autoInjectable } from 'tsyringe';
import HMRManager from './javascript/Utils/HMRManager';
import SceneRegistry from './javascript/Utils/SceneRegistry';

declare global {
    interface Window {
        skipObtainToken: boolean;
        app: Application;
        hmr: HMRManager;
        sceneRegistry: SceneRegistry;
    }
}

@autoInjectable()
export default class Bootstrap {
    private app: Application | null = null;
    private tokenFromLocalStorage: string = '';

    public constructor(public redirectService?: RedirectService) {
        this.initialize();
    }

    private initialize(): void {
        const urlParams = new URLSearchParams(window.location.search);
        const user = urlParams.get('user');
        const tokenFromUrl = urlParams.get('token');
        this.tokenFromLocalStorage = localStorage.getItem('token');
        window.skipObtainToken = false;

        if (window.location.hash === '#debug') {
            this.startApplication();
            return;
        }

        this.redirectService.initialize();

        if (tokenFromUrl) {
            this.clearAllTokens();
            localStorage.setItem('refresh-token', tokenFromUrl);

            window.location.href = window.location.pathname;
            return;
        }

        if (this.isTokenValid()) {
            window.skipObtainToken = true;
            this.startApplication();
        } else if (user) {
            this.clearAllTokens();
            this.startApplication();
        } else {
            if (!localStorage.getItem('refresh-token') && window.location.hash !== '#debug') {
                window.location.href = envierments.baseURL;
                return;
            }
        }

        if (localStorage.getItem('refresh-token')) {
            this.delayedAppStart();
        }
    }

    private clearAllTokens(): void {
        localStorage.removeItem('token');
        localStorage.removeItem('refresh-token');
    }

    private isTokenValid(): boolean {
        if (!this.tokenFromLocalStorage) {
            return false;
        }

        try {
            const decodedToken = jwtDecode(this.tokenFromLocalStorage);
            //@ts-ignore
            return Date.now() < decodedToken.exp * 1000;
        } catch (e) {
            this.clearAllTokens();
            return false;
        }
    }

    private startApplication(): void {
        this.app = new Application();
        this.app.init({
            $canvas: document.querySelector('.js-canvas') as HTMLCanvasElement,
            domContainer: document.querySelector('.container') as HTMLDivElement,
        });

        this.showGame();
    }

    private delayedAppStart(): void {
        setTimeout(() => {
            this.app = new Application();
            this.app.init({
                $canvas: document.querySelector('.js-canvas') as HTMLCanvasElement,
                domContainer: document.querySelector('.container') as HTMLDivElement,
            });
            this.showGame();
        }, 2000);
    }

    private showGame(): void {
        document.querySelector('.game')?.classList.remove('hidden');
    }
}
